import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { aspectRatios } from "@churchofjesuschrist/eden-style-constants";
const ratios = aspectRatios.reduce((acc, _ref) => {
  let {
    key,
    width,
    height
  } = _ref;
  return { ...acc,
    [key]: `${100 * height / width}%`
  };
}, {});
const Container = styled.div.withConfig({
  componentId: "sc-a7o7zu-0"
})(["position:relative;overflow:hidden;&:before{display:block;content:\"\";width:100%;", ";}"], _ref2 => {
  let {
    ratio
  } = _ref2;
  return `padding-block-start: ${ratios[ratio]}`;
});
const Content = styled.div.withConfig({
  componentId: "sc-a7o7zu-1"
})(["position:absolute;top:0;left:0;right:0;bottom:0;"]);
const AspectRatio = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    children,
    ratio = "1:1",
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(Container, {
    ratio: ratio
  }, /*#__PURE__*/React.createElement(Content, {
    ref: ref
  }, children)));
});
AspectRatio.displayName = "AspectRatio";
AspectRatio.propTypes = {
  /** Aspect ratio in which you want the content displayed, in the form of n:n (e.g. "1:1", which is square) */
  ratio: PropTypes.oneOf(["1:1", "5:6", "5:8", "6:5", "8:3", "8:5", "16:9"]),

  /** Content to render inside the AspectRatio Component */
  children: PropTypes.node
};
export default AspectRatio;